"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMappedData = void 0;
exports.isArrayFieldValid = isArrayFieldValid;
var _jsonpathPlus = require("jsonpath-plus");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var getMappedData = function getMappedData(pre2kartCampaigns, Pre2KartFieldPaths) {
  return pre2kartCampaigns.map(function (campaign) {
    var _JSONPath = (0, _jsonpathPlus.JSONPath)({
        path: Pre2KartFieldPaths.offerIdPath,
        json: campaign
      }),
      _JSONPath2 = _slicedToArray(_JSONPath, 1),
      offerId = _JSONPath2[0];
    var _JSONPath3 = (0, _jsonpathPlus.JSONPath)({
        path: Pre2KartFieldPaths.titlePath,
        json: campaign
      }),
      _JSONPath4 = _slicedToArray(_JSONPath3, 1),
      title = _JSONPath4[0];
    var _JSONPath5 = (0, _jsonpathPlus.JSONPath)({
        path: Pre2KartFieldPaths.shortDescriptionPath,
        json: campaign
      }),
      _JSONPath6 = _slicedToArray(_JSONPath5, 1),
      shortDescription = _JSONPath6[0];
    var _JSONPath7 = (0, _jsonpathPlus.JSONPath)({
        path: Pre2KartFieldPaths.priceValuePath,
        json: campaign
      }),
      _JSONPath8 = _slicedToArray(_JSONPath7, 1),
      price = _JSONPath8[0];
    var _JSONPath9 = (0, _jsonpathPlus.JSONPath)({
        path: Pre2KartFieldPaths.catalogPriceValuePath,
        json: campaign
      }),
      _JSONPath10 = _slicedToArray(_JSONPath9, 1),
      catalogPrice = _JSONPath10[0];
    var _JSONPath11 = (0, _jsonpathPlus.JSONPath)({
        path: Pre2KartFieldPaths.priceUnitPath,
        json: campaign
      }),
      _JSONPath12 = _slicedToArray(_JSONPath11, 1),
      currencyUnit = _JSONPath12[0];
    var _JSONPath13 = (0, _jsonpathPlus.JSONPath)({
        path: Pre2KartFieldPaths.imageUrlPath,
        json: campaign
      }),
      _JSONPath14 = _slicedToArray(_JSONPath13, 1),
      imageUrl = _JSONPath14[0];
    return {
      offerId: offerId,
      title: title,
      shortDescription: shortDescription,
      price: price,
      catalogPrice: catalogPrice,
      currencyUnit: currencyUnit,
      imageUrl: imageUrl
    };
  });
};
exports.getMappedData = getMappedData;
function isArrayFieldValid() {
  var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return field && (field === null || field === void 0 ? void 0 : field.length) > 0;
}